<template>
  <div  v-loading="!isPosted">
    <div class="box" v-if="isPosted&&isPay==2">
      <el-row style="margin-bottom:20px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>个人主页</el-breadcrumb-item>
        </el-breadcrumb>
      </el-row>

      <div class="data_bankbox" :style="{'background-image': `url(${info.userInfo.theme_img})`}" >
        <div class="data_bankbox_childa">
          <div>兼职号：{{ info.jz_number }}</div>
          <div style="cursor: pointer;" @click="seeResume">查看简历</div>
        </div>
       

        <div class="data_bankbox_childb">
          <div class="data_childb_a">
            <img :src="info.user_avatar" alt="" />
            <div class="data_childb_a_child">
              <div>
                <h2 style="padding-right: 10px;">{{ info.name }}</h2>
                <span>{{ info.is_real_str }}</span>
              </div>
              <div>{{ info.description }}</div>
            </div>
          </div>
          <div class="data_childb_b">
            <div class="data_childb_b_child">
              <div>
                <div>{{ info.popularity }}</div>
                <div>人气</div>
              </div>
              <div>
                <div>{{ info.credit }}</div>
                <div>信用</div>
              </div>
              <div>
                <div>{{ info.fans }}</div>
                <div>粉丝</div>
              </div>
              <div>
                <div>{{ info.focus }}</div>
                <div>关注</div>
              </div>
            </div>
            <div class="data_childb_b_childs">
              <div @click="attention" class="btn1" v-show="info.is_follow == 2 && info.is_user != 1">
                关注
              </div>
              <div @click="cancel" class="btn1" v-show="info.is_follow == 1 && info.is_user != 1">
                已关注
              </div>
              <div class="btn2" v-show="info.is_user !=1" @click="goChat">去聊呗</div>

              <div class="btn2" v-show="info.is_user == 1" @click="theme">更换背景</div>


            </div>

          </div>
        </div>
      </div>

      <div class="popularize">
            <el-collapse accordion>
            <el-collapse-item>
              <template slot="title">
                该人才由<text>{{ info.popularize.belong_alias_name }}</text>推广<i class="header-icon el-icon-info"></i>
              </template>
              <div>推广语：{{ info.popularize.recommend_mark }}</div>
              <div>工作经历：{{  info.popularize.works }}</div>
            </el-collapse-item>
          </el-collapse>
     </div>

      <div class="aside_box" style="display: flex;justify-content: space-between;">
        <div class="divs" style="width: 45%;">
          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">工作意向</div>
            </div>
            <span class="right" v-if="info.is_user==1" @click="editJobIntention">
              编辑
            </span>
          </div>

          <div>
            <div class="infos"  v-if="info.userInfo.job_intention.length>0">
            <span  class="grey" v-for="(item,index) in info.userInfo.job_intention" :key="index">{{ item }}</span>
           </div>
            <el-empty v-if="!info.userInfo.job_intention||info.userInfo.job_intention.length<=0" :image-size="80" description="暂无数据" style="padding:0px !important"></el-empty>
          </div>
        </div>

        <div class="divs" style="width: 45%;">
          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">所属专业</div>
            </div>
            <span class="right" v-if="info.is_user==1" @click="editMajor">
              编辑
            </span>
          </div>

          <div class="infos"  v-if="info.userInfo.major.length>0">
            <span  class="grey" v-for="(item,index) in info.userInfo.major" :key="index">{{ item }}</span>
          </div>
          <el-empty v-if="!info.userInfo.major||info.userInfo.major.length<=0" :image-size="80" description="暂无数据" style="padding:0px !important"></el-empty>
        </div>

      </div>  


      <div class="aside_box">
        <div class="divs">
          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">空闲时间</div>
            </div>
            <span class="right" v-if="info.is_user==1" @click="editFreeTime">
              编辑
            </span>
          </div>
    
          <div class="timesty"  v-if="info.userInfo.free_times.length>0">
            <div v-for="(item, index) in info.userInfo.free_times" :key="index" class="time_child">
              {{ item&&item.length>0&&Array.isArray(item)?item.join("至"):"" }}
            </div>
          </div>

          <el-empty v-if="!info.userInfo.free_times||info.userInfo.free_times.length<=0" :image-size="80" description="暂无数据" style="padding:0px !important"></el-empty>
        </div>
      </div> 
    

      <div class="aside_box">
        <div class="divs">

          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">工作记录</div>
            </div>
            <span class="right" v-if="info.is_user==1">
              
            </span>
          </div>


          <div style="padding: 20px">
            <el-table :data="info.enroll_records" style="width: 100%" min-height="100">
              <el-table-column label="" fixed prop="company_name" > </el-table-column>
              <el-table-column prop="title"> </el-table-column>
              <el-table-column prop="wages_way"> </el-table-column>
              <el-table-column prop="min_time"> 
                <template slot-scope="{row}">
                  <span>{{ row.min_time }}</span>至
                  <span>{{ row.min_time }}</span>
                </template>

              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

    

      <div class="aside_box">
        <div class="divs">

          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">个人特长</div>
            </div>
            <span class="right" v-if="info.is_user==1" @click="editSpecialty">
              编辑
            </span>
          </div>

          <el-empty v-if="!info.userInfo.specialty||info.userInfo.specialty.length<=0" :image-size="80" description="暂无数据" style="padding:0px !important"></el-empty>

          <div class="infos"  v-if="info.userInfo.specialty.length>0">
            <span  class="grey" v-for="(item,index) in info.userInfo.specialty" :key="index">{{ item }}</span>
          </div>

        </div>
      </div>



      <div class="aside_box">
        <div class="divs">

          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">形象展示</div>
            </div>
            <span class="right" v-if="info.is_user==1" @click="editDisplay">
              编辑
            </span>
          </div>

          <div style="padding: 20px">
            <viewer>
              <img v-for="(item, index) in info.userInfo.img_dispaly" :key="index" :src="item" style="width: 100px; height: 100px" />
            </viewer>
          </div>

        </div>
      </div>

      <div class="aside_box">
        <div class="divs">

          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">个人证书</div>
            </div>
            <span class="right" v-if="info.is_user==1" @click="editCert">
              编辑
            </span>
          </div>

          <div style="padding: 20px">
            <viewer>
              <img v-for="(item, index) in info.userInfo.certificates" :key="index" :src="item" style="width: 100px; height: 100px" />
            </viewer>
          </div>


        </div>
      </div>

      <div class="aside_box">
        <div class="divs">

          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">用户评价</div>
            </div>
            <span class="right" v-if="info.is_user==1">
              {{ info.userInfo.introduce }}
            </span>
          </div>


          <div style="div_childs">&emsp;&emsp;暂无数据</div>
        </div>
      </div>

      <div class="aside_box" style="margin-bottom: 20px">
        <div class="divs">

          <div class="div_child">
            <div class="left">
              <div class="flag"></div>
              <div style="padding-left: 30px">好友印象</div>
            </div>
            
          </div>
          
          <div style="div_childs">&emsp;&emsp;暂无数据</div>
        </div>
      </div>
    </div>
    <div class="box" v-if="isPosted&&isPay==1">
      <div>
        <div style="text-align:center;">
          <span>支付金额:</span>
          <span style="color:red;">￥{{payInfo.money}}</span>
          <span>元</span>
        </div>
        <div class="qrcode" ref="qrcodeContent"></div>

        <div style="text-align:center;">
          <span>请使用微信扫码支付</span>
        </div>
      </div>
    </div>
    <theme-dialog ref="themeRefDialog" @refresh="getInfo"></theme-dialog>
    <major-dialog ref="majorRefDialog" @refresh="getInfo"></major-dialog>
    <intention-dialog ref="intentionRefDialog" @refresh="getInfo"></intention-dialog>
    <specialty-dialog ref="specialtyRefDialog" @refresh="getInfo"></specialty-dialog>
    <display-dialog ref="displayRefDialog" @refresh="getInfo"></display-dialog>
    <cert-dialog ref="certRefDialog" @refresh="getInfo"></cert-dialog>
    <times-dialog ref="timesRefDialog" @refresh="getInfo"></times-dialog>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

import { memberInfo ,checkPay} from "@/api/common/index";


import {followCancelApi,doFollowApi,popularizePayApi} from "@/api/relation/index.js";

import { mapGetters } from 'vuex'

import themeDialog from "@/views/member/dialog/member-theme-dialog.vue";
import intentionDialog from "@/views/member/dialog/member-intention-dialog.vue";
import majorDialog from "@/views/member/dialog/member-major-dialog.vue";
import specialtyDialog from "@/views/member/dialog/member-specialty-dialog.vue";
import timesDialog from "@/views/member/dialog/member-times-dialog.vue";


import displayDialog from "@/views/member/dialog/member-display-dialog.vue";
import certDialog from "@/views/member/dialog/member-certificates-dialog.vue";


export default {
  components: {themeDialog, majorDialog,specialtyDialog,displayDialog,certDialog,intentionDialog,timesDialog},

  computed: {
    ...mapGetters([
      'userInfo',
      'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },
  data () {
    return {
      id: "",
      isPosted:false,
      isPay:2,
      payInfo:null,
      payStatus:false,
      info: {
        is_user:2,
        userInfo:{
          job_intention:[],
          major:[],
          free_times:[],
          img_dispaly:[],
          specialty:[],
          certificates:[]
        }
      },
      loading: false,

    };
  },
  created () {
    this.id = this.$route.query.id;
    this.getInfo();

  },

  methods: {

    getInfo () {
      memberInfo({ user_app_id: this.id }).then((res) => {
        console.log(res);
        this.isPosted=true;
        if(res.code==200){
          if(res.data.is_pay==1){
            this.isPay=1
            this.getPayInfo();
          }else{
            this.isPay=2
            this.info = res.data;
          }
         

        }else{
          this.$message({
            type: "error",
            message: res.msg,
          });
        } 
      });
    },
    //工作意向
    editJobIntention(){
      this.$refs.intentionRefDialog.init(this.info.userInfo.job_intention);

    },

    editMajor(){
      this.$refs.majorRefDialog.init(this.info.userInfo.major);
    },

    editSpecialty(){
      this.$refs.specialtyRefDialog.init(this.info.userInfo.specialty);
    },

    editDisplay(){
      this.$refs.displayRefDialog.init(this.info.userInfo.img_dispaly);
    },

    editCert(){
      this.$refs.certRefDialog.init(this.info.userInfo.certificates);
    },


    editFreeTime(){
      this.$refs.timesRefDialog.init(this.info.userInfo.free_times);

    },
    
    theme(){
      if(this.info.is_user==1){
        
        this.$refs.themeRefDialog.init();
      }

    },

    seeResume(){

    },
  

     getPayInfo(){
      var that=this;
      popularizePayApi({ user_app_id: this.id,pay_type:'wechat' }).then((res) => {
        console.log(res);
        if (!res || !res.data) {
          this.$message({ type: "error", message: "获取支付信息失败" });
          return;
        }
        this.payInfo=res.data;

        let charge_no = res.data.charge_no;
        if (!charge_no) return;
        let timer = setInterval(() => {
          checkPay({charge_no:charge_no}).then(res => {
            if (res.code == 200) {
              this.payStatus = true;
                this.$message({
                  type: "success",
                  message: "支付成功"
                });
                clearInterval(timer);
                that.getInfo();
            } else {
              if (this.payStatus == true) {
                clearInterval(timer);
              }
            }
          });
        }, 2000);
        if (res.data.code_url) {
          that.makeQrCode(res.data.code_url);
        }
       
      }).catch(() => {
        this.payInfo = {};
      });
    },



    //关注
    attention () {
      doFollowApi({ user_app_id: this.info.user_app_id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "已关注",
          });
          this.getInfo();
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },
    //取关
    cancel () {
      followCancelApi({ user_app_id: this.info.user_app_id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "取消关注",
          });
          this.getInfo();
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },



    makeQrCode(url) {
        var that = this
        setTimeout(() => {
              var qrcode = new QRCode(that.$refs.qrcodeContent, {
                  text: url, // 需要转换为二维码的内容
                  width: 100,
                  height: 100,
                  colorDark: '#000000',
                  colorLight: '#ffffff' ,
                  correctLevel: QRCode.CorrectLevel.H
              })
        }, 0)
      },
   

    goChat(){
      this.$goChat(this.userInfo.user_app_id,this.info.user_app_id);
    },
  },
};
</script>

<style lang='scss' scoped>

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

.box {
  width: 1200px;
  margin: auto;

  .qrcode{
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 20px;
  }
  .aside_header {
    padding: 20px 0;
  }

  .aside_box {
    margin-top: 20px;

    .flag {
      width: 12px;
      height: 40px;
      background-color: #4c71db;
    }
    .divs {
      // width: 49%;
      border: 1px solid #999999;
      opacity: 1;
      border-radius: 8px;
      padding: 20px 0;

      .infos{
        padding-left: 42px; margin-top: 20px;

        .grey{
          background-color: #dddddd;
          color: #666666;
          padding: 5px 10px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      .div_child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 150px;
          height: 150px;
          border-radius: 15px;
          margin-right: 25px;
        }
        .left{
          display: flex;
          align-items: center;
        }
        .right{
          margin-right: 20px;
          color: #4c71db;
          cursor: pointer;

          a{
            margin-left: 20px;
            color: #4c71db;
            cursor: pointer;
          }
        }
      }
      .timesty {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 20px;
        flex-wrap: wrap;
        .time_child {
          margin: 10px 0;
          border: 1px solid #ccc;
          color: #4c71db;
          padding: 5px 8px;
          width: 30%;
          margin-right: 20px;
          text-align: center;
        }
      }
    }
  }
  .data_bankbox {
    border-radius: 8px;
    padding: 20px 20px 50px 20px;
    background-color: #ccc;
    color: white;
    .data_bankbox_childa {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .data_bankbox_childb {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .data_childb_a {
        display: flex;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .data_childb_a_child {
          height: 80px;
          display: flex;
          padding-left: 10px;
          flex-direction: column;
          justify-content: space-between;
          // align-items: center;
          div:nth-child(1) {
            display: flex;
            align-items: center;
            span {
              font-size: 0.1rem;
              color: black;
              padding: 0 3px;
              background-color: white;
            }
          }
        }
      }
      .data_childb_b {
        width: 800px;
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .data_childb_b_childs {
          display: flex;
          align-items: center;
          font-size: 12px;
          .btn1 {
            margin-left: 20px;
            margin-right: 20px;
            height: 30px;
            padding: 0px 20px;
            color: #4c71db;
            border: 1px solid #4c71db;
            border-radius: 30px;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .btn2 {
            height: 30px;
            padding: 0px 20px;
            color: white;
            border-radius: 30px;
            background-color: #4c71db;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
        }
        .data_childb_b_child {
          display: flex;
          div {
            margin: 0 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
